<template>
  <div class="animated fadeIn">
    {{ testPackageSample.name }}: {{ getAnalyteNames(testPackageSample.getTestPackageAnalytes()) }}
  </div>
</template>

<script>
  export default {
    name: 'SubmissionSampleAnalytes',
    props: {
      testPackageSample: {
        type: Object,
        default: () => null
      },
    },
    methods: {
      getAnalyteNames(package_analytes) {
        let temp = [];
        if(package_analytes && package_analytes.models.length) {
          package_analytes.models.forEach((package_analyte) => {
            let analyte = package_analyte.getAnalyte();
            if(analyte) {
              temp.push(analyte.abbrev);
            }
          });
        }
        return temp.join(', ');
      },
    },
    created() {
    }
  }
</script>
